import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
    excelMapping,
    ExportToExcel,
    twoDecimalPlaces,
    inWords
} from "../../utils/utilFuctions";
import { BASE_URL_API, BASE_URL_APISERVICES, BASE_URL_API_TRANXT_API } from "../../utils/Constants";
import { CLIENT } from "../../config";
import { GlobalContext } from "../../Context/GlobalState";
import { offsetArr } from "../../utils/CommonConfig";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import swal from "sweetalert";
import { getPaynnowTransactionStatus, getPaynnowTransactionStatus2 } from "../util/utility";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import popupImage from "../../../assets/images/invoice.png";
import { adminAuth } from "../../config";
export const columns = [

    {
        dataField: "tid",
        text: "TXN ID",
    },
    {
        dataField: "user_code",
        text: "User Code",
    },
    {
        dataField: "user_name",
        text: "User",
    },
    {
        dataField: "user_mobile",
        text: "Mobile",
    },
    {
        dataField: "accountNumber",
        text: "Account",
    },
    {
        dataField: "opening_bal",
        text: "Opening Balance",
    },
    {
        dataField: "amount",
        text: "Amount",
    },
    {
        dataField: "closing_bal",
        text: "Closing Balance",
    },
    {
        dataField: "charges",
        text: "Charges",
    },
    {
        dataField: "sales_user_name",
        text: "Sales Person",
    },
    {
        dataField: "rch_com_distributer",
        text: "Dist Commission",
    },
    {
        dataField: "rch_com_cnf",
        text: "MD Commission",
    },
    {
        dataField: "status",
        text: "Status",
    },
    {
        dataField: "date",
        text: "Date",
    },
];

const LoadRequestTable = () => {
    const { username1, password1 } = adminAuth;
    const [pageAccess, setPageAccess] = useState({});
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [offset, setOffset] = useState(10);
    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [pages, setPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const { user, setTransactionLoaderState } = useContext(GlobalContext);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [billDetails, setBillDetails] = useState({});
    const [amount, setAmount] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [slipUrl, setSlipUrl] = useState("");
    const [slipModalOpen, setSlipModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [loadDetails, setLoadDetails] = useState(null);


    const handleShow = () => setShowModal(true);
    // const handleClose = () => setShowModal(false);


    const [selectedRowData, setSelectedRowData] = useState(null);
    const [isSideSectionVisible, setIsSideSectionVisible] = useState(false);
    const handleRowClick = (rowData) => {
        setSelectedRowData(rowData);
        setIsSideSectionVisible(true);
    };

    const handleClose = () => {
        setIsSideSectionVisible(false);
    };

    const dateFormatter = (date) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };
    const now = (date = new Date()) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };
    const fetchVendorPaymentsReport = async () => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
            );
            var raw = JSON.stringify
                ({
                    userid: "",
                    adminId: user.pkid,
                    fromDate: dateFormatter(startDate),
                    toDate: dateFormatter(endDate),
                });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}/api/Admin/v1.0/getLoadRequests`,
                requestOptions
            )

                .then((response) => response.json())
                .then((result) => {
                    if (result.responseCode == "00") {
                        setData(result.data);
                    } else {
                        setData([]);
                    }
                })
                .catch((error) => console.log("error", error));
        } catch (error) {
            console.log(error);
        }
    };

    const fetchData = () => {
        fetchVendorPaymentsReport(startDate, endDate);
    };

    const getTransactionStatus = async (tid) => {
        const data = await getPaynnowTransactionStatus(tid);
        if (data.responseCode == "00") {
            swal("Success", `Status : ${data.status}`, "success");
        } else {
            swal("Failed", `Status : ${data.status}`, "error");
        }
    }

    const getTransactionStatus2 = async (tid) => {
        const data = await getPaynnowTransactionStatus2(tid);
        if (data.responseCode == "00" && data.data.status.toString().toLowerCase() == "success") {
            let message = "";
            if (data.data.status) {
                message = `API Status : ${data.data.txnStatus} \n`;
            }
            if (data.data.responseMessage) {
                message += `${data.data.responseMessage}`;
            }
            if (data.data.channelReferenceNo) {
                message += ` with RRN [${data.data.channelReferenceNo}]`;
            }
            swal("Success", message, "success");
            // swal("Success", `Status : ${data.data.status} [${data.data.responseMessage}] with RRN [${data.data.channelReferenceNo}]`, "success");
        } else {
            swal("Failed", `Status : ${data.status}`, "error");
        }
    }


    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
        setTotal(filteredData.length);
        const startIdx = 0;
        const endIdx = offset - 1;
        filteredData = filteredData.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        setCurrentPage(1);
    }, [searchText]);

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        console.log(filteredData);
        const startIdx = (currentPage - 1) * offset;
        const endIdx = currentPage * offset - 1;
        console.log({ startIdx, endIdx });
        filteredData = filteredData.filter((bank, idx) => {
            console.log(idx, idx <= endIdx && idx >= startIdx);
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        console.log({ startIdx, endIdx });
    }, [currentPage]);

    // did mount
    useEffect(() => {
        setPages(Math.floor((data.length + (offset - 1)) / offset));
        const startIdx = 0;
        const endIdx = offset - 1;
        setTotal(data.length);
        console.log(startIdx);
        console.log(data);
        const filteredData = data.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        console.log(filteredData);
        setDataToDisplay(filteredData);
    }, [data, offset]);


    const searchBarStyle = {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ccc',
        borderRadius: '6px',
        padding: '0px',
        backgroundColor: '#fff',
        width: '15%', // Adjust the width as needed
        height: '20%',

    };
    const inputStyle = {
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        fontSize: '16px',
        marginLeft: '8px',
        width: '100%',
        "fontFamily": "Poppins",
        "fontWeight": "400",
    };
    const iconStyle = {
        color: 'rgba(0, 0, 0, 0.5)',
    };

    const positionStyle = {
        position: 'absolute',
        top: -27,
        left: 0,
        "fontFamily": "Poppins", color: 'rgba(255, 255,255, 1)',
    };
    const positionStyle1 = {
        position: 'absolute',
        top: -38,
        left: 0,
        "fontFamily": "Poppins", color: 'rgba(255, 255,255, 1)',
    };

    const getPageAccess = (menuId) => {
        const sub_menus_access_info = JSON.parse(sessionStorage.getItem("sub_menus"));
        sub_menus_access_info.forEach((acc) => {
            if (acc.pk_menu_id == menuId) {
                setPageAccess(acc);
            }
        })
    }

    const setModalData = (billDetails) => {
        setBillDetails(billDetails);
        setModalOpen2(true);
    };


    useEffect(() => {
        fetchVendorPaymentsReport()
        getPageAccess(14);
    }, [])

    const openInNewTab = (data) => {
        localStorage.setItem(
            "print",
            JSON.stringify({ ...data, })
            // shopName: Profileinfo.shopname
        );
        const newWindow = window.open(
            `/pages/vendor_print2?id=${data.rch_transaction_id}&type=IMPS`,
            "",
            "height=600,width=800'"
        );
    };

    const openSlipModal = (url) => {
        setSlipUrl(url);
        setSlipModalOpen(true);
    };
    const openModal = (details) => {
        setLoadDetails(details);
        setModalOpen(true);
    };


    return (

        <>
            <ViewLoadModal
                details={loadDetails}
                isModalOpen={modalOpen}
                setModalOpen={(modalState) => {
                    setModalOpen(modalState);
                }}
            />
            <ViewSlipModal
                details={slipUrl}
                isModalOpen={slipModalOpen}
                setModalOpen={(modalState) => {
                    setSlipModalOpen(modalState);
                }}
            />


            <div>
                <div className="row m-0 p-0  pt-1 align-items-center">
                    <div className="col-3 m-0 p-0">
                        <div
                            className="m-0 p-0 pl-3 align-top"
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "600",
                                lineHeight: "48px",
                                letterSpacing: "0em",
                                textAlign: "left",
                                padding: "0px",
                                background: "#FFFFFF",
                                color: "#4267B2",
                                fontWeight: "bolder",
                                fontfamily: "Poppins !impotent",
                                fontSize: "28px",
                            }}
                        >
                            Load Request  Report
                        </div>
                    </div>

                    <div className="col-9 m-0 p-0 ">
                        <div className="row m-0 p-0 justify-content-end">
                            <div style={searchBarStyle} className="bg-light m-0 p-0 pr-2">
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    style={iconStyle}
                                    className="ml-2"
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    aria-label="Search"
                                    style={inputStyle}
                                    onChange={(e) => {
                                        setSearchText(e.target.value);
                                    }}
                                    value={searchText}
                                />
                            </div>

                            <div
                                className="pr-1 pl-2 p-0 m-0"
                                style={{ width: "18%", height: "20%" }}
                            >
                                <Form.Group className="p-0 m-0">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        className="form-control rounded-100"
                                        placeholderText="Start Date"
                                    />
                                </Form.Group>
                            </div>
                            <div
                                className="px-1 p-0 m-0"
                                style={{ width: "18%", height: "20%" }}
                            >
                                <Form.Group className="p-0 m-0">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        className="form-control rounded-100"
                                        placeholderText="End Date"
                                    />
                                </Form.Group>
                            </div>

                            <div
                                className="pl-1 p-0 m-0"
                                style={{ width: "14%", height: "20%" }}
                            >
                                <Form.Group className="mt-0 p-0 m-0">
                                    <Button
                                        className=" btn btn-primary btn-lg btn-block "
                                        style={{
                                            background: "#4267B2",
                                            color: "white"
                                        }}
                                        onClick={fetchData}
                                    >
                                        {"Search"}
                                    </Button>
                                </Form.Group>
                            </div>

                            <div
                                className="m-0 p-0 hover-container"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    ExportToExcel(
                                        `CMS_REPORT_${now()}`,
                                        excelMapping(data, columns)
                                    );
                                }}
                            >
                                <img
                                    className="pl-1 p-0"
                                    src={require("../../../assets/images/download Icon.png")}
                                    style={{ width: `3.5rem`, height: "85%" }}
                                />
                                <div style={positionStyle1} className="hover-text bg-dark ">
                                    Export to Excel
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="m-0 p-0" />

                <div style={{ width: "100%" }}>
                    <div style={{ alignItems: "center" }}>
                        <div style={{ flex: "1" }}></div>
                    </div>
                </div>
                <div className="scroll-inner admin-fix-width borderless-table" style={{ overflowX: 'auto' }}>
                    <table
                        className="my-table transparent-table text-center border-bottom"
                        style={{ width: "100%", minWidth: "1200px", border: "0px", whiteSpace: "nowrap" }}
                    >
                        <tr className="borderless-table text-center border-bottom"
                        >
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}> {"Sr"}</th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Txnt ID
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                User
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Load Id
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                UTR No
                            </th>

                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Mode
                            </th>

                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Bank
                            </th>

                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Amount
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Status
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Date
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Remark
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Admin Remark
                            </th>

                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Matching
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Matching Status
                            </th>
                            <th className="my-table transparent-table text-center border-bottom " style={{ "fontFamily": "Poppins", "fontSize": "16px", "fontWeight": "700", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                Action
                            </th>

                        </tr>
                        {dataToDisplay.map((e, ind) => (
                            <tr className="border-bottom clickable-row"
                            >
                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    {" "}
                                    {ind + 1}
                                </td>
                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.id}</div>
                                </td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.user_code}</div>
                                    <div>{e.user_name}</div>
                                    <div>{e.user_mobile}</div></td>
                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.load_id}</div>
                                </td>
                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.load_utrno}</div>
                                </td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{twoDecimalPlaces(e.load_paymode)}</div>
                                </td>
                                <td className="text-center  text-bold border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                ><div>{e.bankName}</div>
                                    <div>{e.bankAccountNo}</div>
                                </td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}>
                                    <div>{twoDecimalPlaces(e.load_amount)}</div>

                                </td>

                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    {e.load_status === "Rejected" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#fab1a0",
                                                color: "#c0392b",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontWeight: "500",
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            Rejected
                                        </span>
                                    ) : e.load_status === "Load Added on Credit" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#dff9fb",
                                                color: "#27ae60",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontWeight: "500",
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            Load Added on Credit
                                        </span>
                                    ) : e.load_status === "Pending" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#ffeaa7",
                                                color: "#d35400",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontWeight: "500",
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            Pending
                                        </span>
                                    ) : (
                                        e.load_status
                                    )}
                                </td>



                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.load_indate}</div>
                                    <div>{e.payment_date}</div>
                                    <div>{e.load_update}</div></td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >{e.load_remark}</td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >{e.load_update_remark}</td>
                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                // onClick={() => handleRowClick(e)}
                                >
                                    <div>{e.metchingPercentage}</div>
                                    <div>{e.matchingRemarks}</div></td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    {e.matchingStatus === "Suspected" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#ffeaa7",
                                                color: "#d35400",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontWeight: "500",
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            Suspected
                                        </span>
                                    ) : e.matchingStatus === "Matching" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#dff9fb",
                                                color: "#27ae60",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontWeight: "500",
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            Matching
                                        </span>
                                    ) : (
                                        e.matchingStatus
                                    )}
                                </td>

                                <td className="text-center border-bottom" style={{ fontSize: '0.8rem', "fontFamily": "Poppins", "fontWeight": "400", "lineHeight": "24px", "letterSpacing": "0em", "textAlign": "center" }}
                                >
                                    <Button
                                        style={{

                                            borderRadius: "5px",
                                            border: "1px none",
                                            backgroundColor: 'rgba(255, 255, 255, 1)',
                                            color: 'rgba(255, 164, 27, 1)',
                                            bordercolor: 'rgba(255, 255, 255, 1)',
                                        }} className="btn btn-sm  rounded-100 m-0 p-0 px-1 pb-1 hover-container"
                                        onClick={() => {
                                            openModal(e);
                                        }}
                                    >
                                        {" "}
                                        <img
                                            src={require("../../../assets/images/Add Load.png")}
                                            style={{ width: "" }}
                                        />
                                        <div style={{ color: 'rgba(255, 255,255, 1)', }} className="hover-text bg-dark "> Add Load</div>
                                    </Button>
                                    <Button style={{

                                        borderRadius: "5px",
                                        border: "1px none",
                                        backgroundColor: 'rgba(255, 255, 255, 1)',
                                        color: 'rgba(255, 164, 27, 1)',
                                        bordercolor: 'rgba(255, 255, 255, 1)',
                                    }} className="btn btn-sm  rounded-100 m-0 p-0 px-1"
                                    >
                                        {" "}

                                        <div
                                            onClick={() => {
                                                openSlipModal(
                                                    // `${BASE_URL_API_TRANXT_API}/users_kyc_doc/img_${e.UTR_No}.jpeg`
                                                    `${BASE_URL_API}/users_kyc_doc/img_${e.utR_No}.jpeg`
                                                );
                                            }}
                                            className="hover-container"

                                        >

                                            <img
                                                src={require("../../../assets/images/View Slip.png")}
                                                style={{ width: "" }}
                                            />
                                            <div style={{ color: 'rgba(255, 255,255, 1)', }} className="hover-text bg-dark mb-2 "> View Slip</div>


                                        </div>


                                    </Button>
                                </td>
                            </tr>

                        ))}
                    </table>
                    <Modal
                        show={showModal}
                        onHide={handleClose}
                        centered
                        backdrop="static"
                        keyboard={false}
                        animation={true}
                    >
                        <Modal.Body className="text-center">
                            {/* Add Icon/Image */}
                            <div style={{ animation: "fadeIn 1s", fontFamily: "Poppins" }}>
                                <img
                                    src={popupImage}
                                    alt="Service Disabled"
                                    style={{ width: "80px", marginBottom: "20px" }}
                                />
                                <h4 style={{ color: "rgba(255, 164, 27, 1)" }}>Service Disabled</h4>
                                <p style={{ color: "#6c757d" }}>
                                    The requested service is currently disabled. Please try again later.
                                </p>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center">
                            <Button
                                variant="secondary"
                                onClick={handleClose}
                                style={{
                                    backgroundColor: "rgba(255, 164, 27, 1)",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div
                    className={`side-section ${isSideSectionVisible ? "visible" : ""}`}
                >
                    <button className="close-button" onClick={handleClose}>
                        &times;
                    </button>
                    <h5 className=""><b>Details</b></h5>

                    {selectedRowData && (
                        <div
                            style={{
                                maxHeight: "80%",
                                overflowY: "auto",
                                padding: "5px",
                            }}>
                            <table >
                                <tbody>
                                    <tr className="border-bottom border-top" >
                                        <td style={{ fontSize: "12px", border: "none" }}
                                        >Txnt ID::</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.tid}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >User Code:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.user_code}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >User Name:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.user_name}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Depositor Mobile:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.customer_mobile}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Account:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.accountNumber}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Opening Balance:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.opening_bal)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Amount:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.amount)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Closing Balance:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.closing_bal)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Charges:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.charges)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Sales User Code:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.sales_user_code}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Sales Person Name:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.sales_user_name}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Sales Person Number:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.sales_user_mobile}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Distributor Commission:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.rch_com_distributer)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >MD Commission:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{twoDecimalPlaces(selectedRowData.rch_com_cnf)}</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >Date:</td>
                                        <td
                                            style={{ fontSize: "12px", border: "none" }}
                                        >{selectedRowData.date}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>


                <Pagination
                    page={currentPage}
                    limit={pages}
                    callback={(page) => {
                        setCurrentPage(page);
                    }}
                    count={dataToDisplay.length}
                    total={total}
                    callback2={(offsetValue) => {
                        setOffset(offsetValue);
                    }}
                />
            </div>
        </>
    );
};

export const Pagination = ({
    page,
    limit,
    callback,
    total,
    count,
    callback2,
}) => {
    console.table({ page, limit, callback });
    const selectStyleLeftBorder = {

        borderRadius: '0px',
        "fontFamily": "Poppins",
        'fontsize': '16px',
        borderRight: '1px solid rgba(0, 0, 0, 0.2)', // Remove the border
        borderRadius: '0px',
        borderLeft: 'none', // Remove right side border
        borderTop: 'none', // Remove top border
        borderBottom: 'none', // Remove bottom border
        "fontFamily": "Poppins",
        'fontsize': '16px',




    };
    const selectStyleBorder = {
        border: '1px solid rgba(0, 0, 0, 0.1)', // Remove the border
        borderRadius: '8px',
        "fontFamily": "Poppins",
        'fontsize': '16px',
    };
    const selectStyle = {

        border: 'none', // Remove the border
        "fontFamily": "Poppins",
        'fontsize': '16px',

    };
    return (
        <div
            className="row"
            style={{
                display: "flex",
                alignItems: "end",
                width: "100%",
                margin: "12px 0px",
                justifyContent: "space-between",

            }}
        >
            <div style={{ "fontFamily": "Poppins", }}>
                <strong>{`Showing ${count} of ${total} entries`}</strong>
            </div>


            <div className="d-flex btn-group p-1" style={selectStyleBorder}>
                <select
                    style={selectStyleLeftBorder}
                    className=" d-flex justify-content-end "
                    aria-label="offset"
                    onChange={(e) => {
                        callback2(e.target.value);
                    }}

                >
                    {offsetArr.map((offset) => (
                        <option value={offset} className="d-flex justify-content-end">{offset}</option>
                    ))}

                </select>
                {page - 2 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}

                        className="rounded-0 bg-white text-dark border-white"

                    >
                        {"<<"}
                    </Button>
                ) : null}

                {page - 1 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}

                        className="rounded-0 bg-white text-dark border-white underline-text"
                    >
                        {" "}
                        {(page - 1).toString()}
                    </Button>
                ) : null}



                <Button className="bg-white text-primary " style={selectStyle}> {page.toString()}</Button>




                {/* Next And Previous Button Code */}
                {page + 1 <= limit ? (
                    <Button
                        onClick={() => {
                            callback(page + 1);
                        }}

                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {">>"}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

const ViewSlipModal = ({ details: url, isModalOpen, setModalOpen }) => {
    return (
        <Modal
            show={isModalOpen}
            onHide={() => setModalOpen(false)}
            aria-labelledby="example-modal-sizes-title-md"
            size="xl"
        >
            <Modal.Body
                style={{ height: "100%", display: "block" }}
                className="account"
            >
                <div
                    style={{
                        padding: "12px",
                        background: "#3676D8",
                        color: "#FFF",
                        fontWeight: "bolder",
                    }}
                    className="d-flex justify-content-between"
                >
                    <strong>View Slip</strong>
                    <strong
                        className="px-1 hover"
                        onClick={() => {
                            setModalOpen(false);
                        }}
                    >
                        {" "}
                        X
                    </strong>
                </div>
                {url && (
                    <React.Fragment>
                        <div className="row">
                            <img src={url} style={{ width: "50%", height: "auto" }} />
                        </div>
                    </React.Fragment>
                )}
            </Modal.Body>
        </Modal>
    );
};

const ViewLoadModal = ({ details, isModalOpen, setModalOpen, refresh }) => {
    const twoDecimalPlaces = (value) => {
        return Number(value).toFixed(2).toString();
    };
    const [state, setState] = useState({
        remark: "",
        status: "",
        amount: "0.00",
        loadId: "",
        utr: "",
        bankId: "",
    });
    const { user, setTransactionLoaderState } = useContext(GlobalContext);
    const actions = [
        { label: "Please Select", value: "-1" },
        { label: "Add Load on Credit", value: "4" },
        { label: "Reject Request", value: "3" },
        { label: "Edit Request", value: "5" },
    ];

    const acceptLoadRequest = async () => {
        try {
            setTransactionLoaderState(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                loadId: state.loadId,
                amount: state.amount,
                remark: state.remark,
                status: state.status,
                adminid: user.pkid
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}/api/Payment/admin/adminLoadRequestApprove`,
                requestOptions
            );
            const data = await res.json();
            if (data.status == "0") {
                swal("Load Request Accept Successfully", data.data?.message, "success");
            } else {
                swal("Load Request Accept Failed", data.data?.message, "error");
            }
            setModalOpen(false);
            refresh();
            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);
            swal("Load Request Accept Failed", "Error From Server", "error");
        }
    };

    const updateLoadRequest = async () => {
        try {
            setTransactionLoaderState(true);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4=");

            var raw = JSON.stringify({
                loadRequestId: state.loadId,
                adminId: user.pkid,
                remarks: state.remark
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}/api/Admin/v1.0/updateLoadRequest`,
                requestOptions
            );
            const data = await res.json();
            if (data.responseCode == "00") {
                swal("Edit Request Successfully", data.responseMessage, "success");
            } else {
                swal("Edit Request Failed", data.responseMessage, "error");
            }
            setModalOpen(false);
            refresh();
            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);
            swal("Edit Request Failed", "Error From Server", "error");
        }
    };


    const acceptLoadRequest2 = async () => {
        try {
            setTransactionLoaderState(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                loadId: state.loadId,
                amount: state.amount,
                remark: state.remark,
                status: state.status,
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                // `${BASE_URL_API_TRANXT_API}/api/admin/accept_load_request_admin.aspx`,
                `${BASE_URL_API}/api/Apitranxt/accept_load_request_admin`,
                requestOptions
            );
            const data = await res.json();
            if (data.status == "0") {
                swal("Load Request Accept Successfully", data.data?.result, "success");
            } else {
                swal("Load Request Accept Failed", data.data?.result, "error");
            }
            setModalOpen(false);
            refresh();
            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);
            swal("Load Request Accept Failed", "Error From Server", "error");
        }
    };

    const rejeectLoadRequest = async () => {
        try {
            setTransactionLoaderState(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                loadId: state.loadId,
                amount: state.amount,
                remark: state.remark,
                status: state.status,
                utr: state.utr,
                bankId: state.bankId,
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                // `${BASE_URL_API_TRANXT_API}/api/admin/reject_load_request_admin.aspx`,
                `${BASE_URL_API}/api/Apitranxt/reject_load_request_admin`,
                requestOptions
            );
            const data = await res.json();
            if (data.status == "0") {
                swal("Load Request Reject Successfully", data.data?.result, "success");
            } else {
                swal("Load Request Reject Failed", data.data?.result, "error");
            }
            setModalOpen(false);
            refresh();
            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            swal("Load Request Reject Failed", "Error From Server", "error");
        }
    };
    const submit = () => {
        if (state.remark == "", state.status == "") {
            swal("Invalid", "Please Fill mandatory fields", "error");
            return;
        }
        if (state.status == "4") {
            acceptLoadRequest();
        } else if (state.status == "3") {
            rejeectLoadRequest();
        } else if (state.status == "5") {
            updateLoadRequest();
        } else {
            swal("Invalid", "Please Select Valid Action", "error");
        }
    };
    console.log(details);
    useEffect(() => {
        if (details) {
            setState({
                ...state,
                amount: twoDecimalPlaces(details.Amount),
                loadId: details.Load_Id,
                utr: details.UTR_No,
                bankId: details.load_bankid,
            });
        }
    }, [details]);
    return (
        <Modal
            show={isModalOpen}
            onHide={() => setModalOpen(false)}
            aria-labelledby="example-modal-sizes-title-md"
            size="lg"
        >
            <Modal.Body
                style={{ width: "100%", display: "block" }}
                className="account"
            >

                <div
                    style={{
                        padding: "12px",
                        background: "#FFFFFF",
                        color: "#4267B2",
                        fontWeight: "bolder",
                        fontfamily: "Poppins",
                        fontSize: "32px",
                    }}
                    className="d-flex justify-content-between"
                >
                    <div>Add Load</div>
                    <div
                        className="px-1 hover"
                        onClick={() => {
                            setModalOpen(false);
                        }}
                    >
                        {" "}
                        X
                    </div>
                </div>


                <hr />

                {details && (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-6">Load ID</div>
                            <div className="col-6">{details.load_id}</div>
                        </div>
                        <div className="row">
                            <div className="col-6">Request Load Amount</div>
                            <div className="col-6">{twoDecimalPlaces(details.load_amount)}</div>
                        </div>
                        <div className="row">
                            <div className="col-6">Request Type</div>
                            <div className="col-6">{details.Paymode}</div>
                        </div>

                        <hr />

                        <div className="row">



                            <div className="col-6">
                                <div className="">Action</div>

                                <select
                                    style={{ width: "100%" }}
                                    className="rounded-0 form-select mx-1 p-2  "
                                    aria-label="offset"
                                    onChange={(e) => {
                                        setState({ ...state, status: e.target.value });
                                    }}
                                >
                                    {actions.map((a) => (
                                        <option value={a.value}>{a.label}</option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-6">
                                <div className="">Remarks</div>

                                {" "}
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        className="form-control"
                                        aria-label="Notes"
                                        aria-describedby="basic-addon1"
                                        placeholder="Enter Remarks"
                                        value={state.remark}
                                        onChange={(e) => {
                                            setState({ ...state, remark: e.target.value });
                                        }}
                                        style={{ borderRadius: "0px" }}
                                    />
                                </Form.Group>
                            </div>



                        </div>

                        <div className="row align-items-center">

                            <div className="col-6">
                                <div className="">Add Load</div>

                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        className="form-control"
                                        aria-label="Notes"
                                        aria-describedby="basic-addon1"
                                        placeholder="Enter Amount"
                                        value={state.amount}
                                        onChange={(e) => {
                                            setState({ ...state, amount: e.target.value });
                                        }}
                                        style={{ borderRadius: "0px" }}
                                    />
                                </Form.Group>
                                <strong className="p-1 text-success">
                                    {inWords(Number(state.amount))}
                                </strong>
                            </div>


                            <div className="col-6 ">


                                {" "}
                                <Button
                                    className="rounded-50 btn btn-success  "
                                    onClick={submit}
                                >
                                    Approve
                                </Button>
                                <Button
                                    className="rounded-50 btn btn-danger "
                                    onClick={submit}
                                >
                                    Reject
                                </Button>

                            </div>
                        </div>
                    </React.Fragment>
                )}
            </Modal.Body>
        </Modal>
    );
};
export default LoadRequestTable;